module.exports = __webpack_public_path__ + "static/gallery_14-21ef3e73c010150a31bcacb6aad134e7.jpg";